import type { RequestContext } from '@mortgage-pos/types'

export const SAGE_INTERNAL_SESSION_COOKIE_NAME = 'SAGE_INTERNAL_SESSION'

export const SAGE_INTERNAL_MAX_AGE_SECONDS = 7 * 24 * 60 * 60

export const SAGE_INTERNAL_HEADER = 'x-sage-internal' as const

export function isSageInternalRequest(
  ctx: RequestContext | undefined
): boolean {
  return ctx?.[SAGE_INTERNAL_HEADER] === 'true'
}

export function readSageInternalCookie(): boolean {
  if (typeof document === 'undefined') {
    return false
  }
  const prefix = `${SAGE_INTERNAL_SESSION_COOKIE_NAME}=`
  for (const segment of document.cookie.split(';')) {
    const part = segment.trim()
    if (part.startsWith(prefix)) {
      return part.slice(prefix.length).length > 0
    }
  }
  return false
}

export function setSageInternalCookie(options: {
  domain?: string
  maxAgeSeconds?: number
  secure: boolean
}): void {
  const maxAge = options.maxAgeSeconds ?? SAGE_INTERNAL_MAX_AGE_SECONDS
  let cookie = `${SAGE_INTERNAL_SESSION_COOKIE_NAME}=1;path=/;Max-Age=${maxAge};SameSite=Lax`
  if (options.domain) {
    cookie += `;Domain=${options.domain}`
  }
  if (options.secure) {
    cookie += ';Secure'
  }
  document.cookie = cookie
}
